import { Injectable } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { interval, Observable, Subject } from 'rxjs';
import { debounceTime, filter, throttleTime } from 'rxjs/operators';
import { DataHelper } from '@helpers/data.helper';
import { ApiService } from './api.service';
import { environment } from '@environments/environment';
declare let betaluxBr: any;
@Injectable({
  providedIn: 'root',
})
export class DataService {
  public activeList = {
    getSlipCashOutValues: false, // Only active if user on mobile app.
    getOddComparison: false, // Only active if user on mobile app.
  };
  public apiCalls = {
    getCashoutValueExternal: (cashoutSlipItem: { [key: string]: any }) =>
      new Promise(resolve => {
        if (environment.isNewCashout === false) {
          return this._ApiService
            .getCashoutValueExternal(cashoutSlipItem.SlipId)
            .then(cashoutValue => {
              if (cashoutSlipItem && cashoutValue && cashoutValue.length > 0) {
                const _will_change_cashoutSlipItem = cashoutSlipItem;

                // If cashout value cames from server greater than local one,
                // todo currently we disable animatiion
                if (cashoutSlipItem.CashoutValue > cashoutValue[0].CashOutValue) {
                  _will_change_cashoutSlipItem.State = 0;
                } else if (cashoutSlipItem.CashoutValue < cashoutValue[0].CashOutValue) {
                  _will_change_cashoutSlipItem.State = 0;
                }
                _will_change_cashoutSlipItem.CashoutValue = cashoutValue[0].CashOutValue;
                if (environment.isJacktimeActive === true) {
                  _will_change_cashoutSlipItem.CashOutValueJacktime = Math.floor(cashoutValue[0].CashOutValueJacktime.toFixed(4) * 100) / 100;
                }
                _will_change_cashoutSlipItem.isLive = cashoutValue[0].IsLive;
                _will_change_cashoutSlipItem['details'] = cashoutValue;

                const isLiveMatch = this._DataHelper.liveData.filter((x: { [key: string]: any }) =>
                  cashoutSlipItem.details.map(i => i.BetradarMatchId).includes(x.BetradarMatchId)
                );

                // todo Wtf is this?

                const indexOfItem = this._DataHelper.cashoutSlipsList.findIndex(_cashoutSlipItem => _cashoutSlipItem.SlipId === cashoutSlipItem.SlipId);
                if (indexOfItem > -1) {
                  const _cashoutSlipList = this._DataHelper.cashoutSlipsList;
                  _cashoutSlipList[indexOfItem] = _will_change_cashoutSlipItem;

                  this._DataHelper.cashoutSlipsList = [..._cashoutSlipList];
                }

                resolve({ status: true, data: cashoutValue });
                // if (this._DataHelper.cashoutSlipsList[i].SlipId == this.lastSlipId) {
                //  //////this.consoleLog("V", this.lastSlipId);
                //  this.cashoutSlipDetailList = cashoutValue
                // }
                // this.cashOutValue = cashoutValue[0].CashOutValue;
                // cashoutSlipItem.CashoutSlipDetail = cashoutValue;
              } else {
                resolve({ status: false, msg: 'empty_response' });
              }
            })
            .catch(error => {
              this.consoleLog('Error getCashoutValueExternal: ', error);
              resolve({ status: false });
            });
        } else {
          return this._ApiService
            .getCashoutValueExternal(cashoutSlipItem.SlipId)
            .then(cashoutItem => {
              if (cashoutItem && cashoutItem.success === true) {
                const _will_change_cashoutSlipItem = cashoutSlipItem;

                // If cashout value cames from server greater than local one,
                // todo currently we disable animatiion
                if (cashoutSlipItem.cashoutValue > cashoutItem.cashoutValue) {
                  _will_change_cashoutSlipItem.State = 0;
                } else if (cashoutSlipItem.cashoutValue < cashoutItem.cashoutValue) {
                  _will_change_cashoutSlipItem.State = 0;
                }
                _will_change_cashoutSlipItem.cashoutValue = cashoutItem.cashoutValue;

                const _groupingCashoutItem = {};
                cashoutItem?.details?.forEach(detail => {
                  let _detail = detail;
                  if (!_groupingCashoutItem[detail.matchId]) {
                    _detail = {
                      ...detail,
                      _groupingCashoutItem: [],
                    };
                    _groupingCashoutItem[detail.matchId] = _detail;
                  }

                  _groupingCashoutItem[detail.matchId]._groupingCashoutItem.push(_detail);
                });
                _will_change_cashoutSlipItem['details'] = Object.values(_groupingCashoutItem);

                if (!this._DataHelper.cashoutTimeLineData[cashoutSlipItem.SlipId]) {
                  this._DataHelper.cashoutTimeLineData[cashoutSlipItem.SlipId] = [
                    {
                      name: 'STOCK ABC',
                      data: [],
                    },
                  ];
                }
                this._DataHelper.cashoutTimeLineData[cashoutSlipItem.SlipId][0].data.push([new Date().getTime(), cashoutItem.cashoutValue]);

                // todo Wtf is this?

                const indexOfItem = this._DataHelper.cashoutSlipsList.findIndex(_cashoutSlipItem => _cashoutSlipItem.SlipId === cashoutSlipItem.SlipId);
                if (indexOfItem > -1) {
                  const _cashoutSlipList = this._DataHelper.cashoutSlipsList;
                  _cashoutSlipList[indexOfItem] = _will_change_cashoutSlipItem;

                  this._DataHelper.cashoutSlipsList = [..._cashoutSlipList];
                }

                resolve({ status: true });
                // if (this._DataHelper.cashoutSlipsList[i].SlipId == this.lastSlipId) {
                //  //////this.consoleLog("V", this.lastSlipId);
                //  this.cashoutSlipDetailList = cashoutValue
                // }
                // this.cashOutValue = cashoutValue[0].CashOutValue;
                // cashoutSlipItem.CashoutSlipDetail = cashoutValue;
              } else {
                resolve({ status: false, msg: 'empty_response' });
              }
            })
            .catch(error => {
              this.consoleLog('Error getCashoutValueExternal: ', error);
              resolve({ status: false });
            });
        }
      }),
  };
  private isActive = true;
  private betSlipDialog = false;
  isMobileView = false;
  eventListRules: { [name: string]: () => boolean } = {
    getSystemItems: () =>
      (this.isActive && this._UiHelper.currentSlipTabSelected === 2) || (this.isMobileView && this.betSlipDialog && this._UiHelper.currentSlipTabSelected === 2),
    getCurrentSlipAmount: () =>
      (this.isActive && !this.isMobileView && this._DataHelper.currentSlipData.length > 0 && this._UiHelper.currentSlipHeaderTabSelected === 1) ||
      (this.isMobileView && this.betSlipDialog),
    refreshCurrentSlip: () =>
      (this.isActive && !this.isMobileView && this._DataHelper.currentSlipData.length > 0 && this._UiHelper.currentSlipHeaderTabSelected === 1) ||
      (this.isMobileView && this.betSlipDialog),
    getSlipCashOutValues: () => this.isActive && (this._UiHelper.currentSlipHeaderTabSelected === 2 || (this.isMobileView && this.activeList.getSlipCashOutValues === true)),
    getSlipCashOutList: () => this.isActive && (this._UiHelper.currentSlipHeaderTabSelected === 2 || (this.isMobileView && this.activeList.getSlipCashOutValues === true)),
    getOddComparison: () => this.isActive && this._UiHelper.homeSelectedTab === 'compare' && this.activeList.getOddComparison === true,
  };

  eventList: {
    [name: string]: {
      config: { apiCallThrottleTimeMS: number; apiCallDebounceTimeMS?: number };
      executeFunction: (intervalSeconds?: number) => Observable<any>;
      apiCall: () => any;
    };
  } = {
    getSystemItems: {
      config: {
        apiCallThrottleTimeMS: 0,
        apiCallDebounceTimeMS: 1000,
      },
      executeFunction: (intervalSeconds: number) => interval(intervalSeconds * 1000).pipe(filter(() => this.eventListRules['getSystemItems']())),
      apiCall: () => {
        return this._ApiService.getSystemItems().then(result => {
          this._DataHelper.setCurrentSlipSystemInfo(result);
        });
      },
    },
    getCurrentSlipAmount: {
      config: {
        apiCallThrottleTimeMS: 0,
        apiCallDebounceTimeMS: 1000,
      },
      // todo modal active status
      executeFunction: (intervalSeconds: number) => interval(intervalSeconds * 1000).pipe(filter(() => this.eventListRules['getCurrentSlipAmount']())),
      apiCall: () => {
        // todo System, burada anormallik var.
        let systemValues = '';
        if (this._UiHelper.currentSlipTabSelected === 2) {
          if (!(this._DataHelper.currentSlipSystemInfo && this._DataHelper.currentSlipSystemInfo.length > 0)) {
            return;
          }

          systemValues = this._DataHelper.currentSlipSystemInfo
            .map((systemVal, index, array) => {
              return this._DataHelper.currentSlipSystemSelection.includes(`${systemVal.index + 1}_${systemVal.combination}`)
                ? `1${array.length === index + 1 ? '' : ','}`
                : `0${array.length === index + 1 ? '' : ','}`;
            })
            .join('');
        }

        if (this._DataHelper.taxRate != 0) {
          this._DataHelper.currentSlipInfo.toPayNumeric = (this._DataHelper.currentSlipInfo.currentslip_totalStake * 100) / (100 + this._DataHelper.taxRate);
          this._DataHelper.currentSlipInfo.tax = (this._DataHelper.currentSlipInfo.currentslip_totalStake - this._DataHelper.currentSlipInfo.toPayNumeric).toFixed(4);
        } else {
          this._DataHelper.currentSlipInfo.toPay = this._DataHelper.currentSlipInfo.currentslip_totalStake;
          this._DataHelper.currentSlipInfo.toPayNumeric = this._DataHelper.currentSlipInfo.toPay;
          this._DataHelper.currentSlipInfo.tax = '';
        }
        const bonusRate =
          this._DataHelper.customerBoostBonusInfo && this._DataHelper.customerBoostBonusInfo.BonusRate !== undefined ? this._DataHelper.customerBoostBonusInfo.BonusRate : 1;

        this._ApiService
          .getCurrentSlipAmount(
            this._DataHelper.currentSlipInfo.toPayNumeric,
            this._UiHelper.currentSlipTabSelected,
            systemValues,
            this._DataHelper.freebetBonusCheckBox,
            this._DataHelper.boostBonusCheckBox,
            bonusRate
          )
          .then(calc => {
            if (calc != null) {
              let result = {
                AmountPerBet: 0,
                NumberOfBets: 0,
                ToPay: 0,
                MaxGain: 0,
                MinGain: 0,
                TotalRate: 0,
                OldTotalRate: 0,
              };
              if (calc.length > 0) {
                result = calc[0];
              }

              this._DataHelper.currentSlipInfo.amountPerBet = result.AmountPerBet;
              this._DataHelper.currentSlipInfo.numberOfBets = result.NumberOfBets;
              // this._DataHelper.currentSlipInfo.currentslip_totalStake = result.ToPay;
              this._DataHelper.currentSlipInfo.toPay = result.ToPay;
              this._DataHelper.currentSlipInfo.maxGain = result.MaxGain;
              this._DataHelper.currentSlipInfo.minGain = result.MinGain;
              this._DataHelper.currentSlipInfo.totalRate = result.TotalRate;
              this._DataHelper.currentSlipInfo.OldTotalRate = result.OldTotalRate;

              this._DataHelper.currentSlipInfo.maxWinTax = (
                this.parseCurrency(this._DataHelper.currentSlipInfo.toPay) * this.parseCurrency(this._DataHelper.currentSlipInfo.totalRate) -
                this.parseCurrency(this._DataHelper.currentSlipInfo.maxGain)
              ).toString();
              if (typeof betaluxBr !== 'undefined' && betaluxBr.get('betrecommend') && betaluxBr.get('betrecommend').setMaxGain) {
                // remove ',' from max gain
                betaluxBr.get('betrecommend').setMaxGain([result.MaxGain.toString().replace(',', '')]);
              }

              this._DataHelper.currentSlipInfo.currentTotalRate = result.TotalRate;
              this._DataHelper.currentSlipOpened = true;
            }
          });
      },
    },
    getSlipCashOutValues: {
      config: {
        apiCallThrottleTimeMS: 5000,
      },
      executeFunction: (intervalSeconds: number) => interval(intervalSeconds * 1000).pipe(filter(() => this.eventListRules['getSlipCashOutValues']())),
      apiCall: () => {
        const requestResultPromise = this._DataHelper.cashoutSlipsList.map(item => this.apiCalls.getCashoutValueExternal(item));
        this.consoleLog('requestResultPromise', requestResultPromise);
        Promise.all(requestResultPromise)
          .then(res => {
            console.warn('All done');
          })
          .catch(err => console.log(err));
      },
    },
    getSlipCashOutList: {
      config: {
        apiCallThrottleTimeMS: 5000,
      },
      executeFunction: (intervalSeconds: number) => interval(intervalSeconds * 1000).pipe(filter(() => this.eventListRules['getSlipCashOutList']())),
      apiCall: () => {
        this._ApiService
          .getCashoutSlipsExternal(1)
          .then(res => {
            this.fireApiCall('getSlipCashOutValues', true, true);
          })
          .catch(err => console.log(err));
      },
    },
    refreshCurrentSlip: {
      config: {
        apiCallThrottleTimeMS: 5000,
      },
      executeFunction: (intervalSeconds: number) => interval(intervalSeconds * 1000).pipe(filter(() => this.eventListRules['refreshCurrentSlip']())),
      apiCall: () => {
        this._ApiService
          .refreshCurrentSlip()
          .then()
          .catch(err => console.log(err));
      },
    },
    getOddComparison: {
      config: {
        apiCallThrottleTimeMS: 1000 * 60,
        apiCallDebounceTimeMS: 0,
      },
      executeFunction: (intervalSeconds: number) => interval(intervalSeconds * 1000).pipe(filter(() => this.eventListRules['getOddComparison']())),
      apiCall: () => {
        return this._ApiService
          .getOddComparison()
          .then(result => {
            this._DataHelper.setComparisonData(result);
          })
          .catch(err => console.log(err));
      },
    },
  };
  dataGetterList = {};
  apiCallManager = {};
  apiCallManagerSubscription = {};

  constructor(private _UiHelper: UiHelper, private _DataHelper: DataHelper, private _ApiService: ApiService) {
    this._UiHelper.isTabActiveListener.subscribe((isActive: boolean) => {
      this.consoleLog('isActive', isActive);
      this.isActive = isActive;
    });

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });

    this._UiHelper.bottomDialogStateListener.subscribe((state: boolean) => {
      this.betSlipDialog = state;
    });
  }
  parseCurrency(value) {
    return parseFloat(value.replace(/,/g, ''));
  }
  setDataGetter(executeFunctionName: string, intervalSeconds: number) {
    if (this.dataGetterList[executeFunctionName]) {
      this.consoleLog('DataGetter already exists: ', executeFunctionName);
      return;
    }
    try {
      const _data = {
        intervalSeconds,
        subscribe: this.eventList[executeFunctionName].executeFunction(intervalSeconds).subscribe(() => {
          this.consoleLog('executeFunctionName:', executeFunctionName);
          if (this.eventList[executeFunctionName].apiCall) {
            this.eventList[executeFunctionName].apiCall();
          }
        }),
      };

      this.dataGetterList[executeFunctionName] = _data;
      this.consoleLog('DataGetter setted ', executeFunctionName);

      // call immediately
      if (this.eventList[executeFunctionName].apiCall) {
        this.eventList[executeFunctionName].apiCall();
      }
    } catch (e) {
      this.consoleLog('Data Service Error: ', e);
    }
  }

  fireApiCall(eventName: string, isForce?: boolean, bypassRules = false) {
    this.consoleLog('Fire Api Call Externally: ', eventName, this.eventList[eventName]);

    try {
      if (this.eventList[eventName] && this.isActive) {
        let _intervalSeconds = 0;

        // Re-set interval because manually triggered.

        if (this.dataGetterList[eventName]) {
          _intervalSeconds = this.dataGetterList[eventName].intervalSeconds;
          this.removeDataGetter(eventName);
          this.setDataGetter(eventName, _intervalSeconds);
        }

        // Api call manually called.
        this.getApiCall(eventName, isForce, bypassRules);
      } else {
        this.consoleLog('Event is not active');
      }
    } catch (e) {
      this.consoleLog('Data Service Error: ', e);
    }
  }

  getApiCall(eventName: string, isForce?: boolean, bypassRules?: boolean) {
    if (isForce === true) {
      return this.eventList[eventName].apiCall();
    }

    if (this.apiCallManager[eventName]) {
      // Event is found. Just call the api call.
      return this.apiCallManager[eventName].next(true);
    } else {
      // Event declare here.
      // Declare new Subject
      this.apiCallManager[eventName] = new Subject();

      const _pipe = [];
      if (bypassRules === false && this.eventListRules[eventName]) {
        _pipe.push(filter(() => this.eventListRules[eventName]()));
      }

      if (this.eventList[eventName].config.apiCallThrottleTimeMS > 0) {
        this.apiCallManager[eventName] = this.apiCallManager[eventName].pipe(throttleTime(this.eventList[eventName].config.apiCallThrottleTimeMS), ..._pipe);
      }
      if (this.eventList[eventName].config.apiCallDebounceTimeMS > 0) {
        this.apiCallManager[eventName] = this.apiCallManager[eventName].pipe(debounceTime(this.eventList[eventName].config.apiCallDebounceTimeMS), ..._pipe);
      }

      // For api calls create subscription.
      if (!this.apiCallManagerSubscription[eventName]) {
        this.apiCallManagerSubscription[eventName] = this.apiCallManager[eventName].subscribe(() => {
          this.consoleLog(this.apiCallManager[eventName], this.eventListRules[eventName]());
          this.eventList[eventName].apiCall();
        });
      }

      // Get Instantly first time.
      return this.apiCallManager[eventName].next(true);
    }
  }

  removeDataGetter(executeFunctionName: string) {
    if (this.dataGetterList[executeFunctionName]) {
      this.dataGetterList[executeFunctionName].subscribe.unsubscribe();
      delete this.dataGetterList[executeFunctionName];
    }
  }

  consoleLog(...e) {
    // eslint-disable-next-line no-constant-condition
    if (false) {
      console.log(...e);
    }
  }
}
